import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AboutandeventformComponent } from '../about-us/aboutandeventform/aboutandeventform.component';
import { SharingService } from '../../services/share.service';
import { ToastrService } from 'ngx-toastr';
import { UTILITY } from '../../services/util';

@Component({
  selector: 'app-services',
  imports: [CommonModule, AboutandeventformComponent, RouterModule],
  templateUrl: './services.component.html',
  styleUrl: './services.component.scss',
  providers: [DatePipe],
})
export class ServicesComponent {
  toasterTimeout = 3000;
  dateFormat = UTILITY.Date;
  dateTimeFormat = UTILITY.DateTime;
  eventsList: any[] = [];
  showContactSec: boolean = false;
  imgURL: any;
  loader: boolean = false;
  constructor(private svc: SharingService, private toastrService: ToastrService, private datePipe: DatePipe,) {
    this.getEvents();
    this.imgURL = this.svc.base_Url.slice(0, -4);
  }
  getEvents() {
    var url = 'GetEventList';
    let payload = {
      status: 1,
      "is_public": 1
    }
    this.loader = true;
    this.svc.postData(url, payload).subscribe((res: any) => {
      this.loader = false;
      if (res) {
        this.eventsList = res?.data;
      }
    }, err => {
      this.loader = false;
      this.toastrService.clear();
      this.toastrService.error(err.error.message, '', {
        closeButton: true,
        timeOut: this.toasterTimeout
      });
    })
  }
  toggleDescription(item: any): void {
    item.showFullDescription = !item.showFullDescription;
  }

  isTextOverflowing(item: any): boolean {
    // Optional: Always show the toggle or add real DOM check logic if needed
    return item.description?.length > 200; // Adjust this threshold as needed
  }
}
